<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameSetting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameSetting.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('gameSetting.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'game_type.game_type'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.game_setting }}</td>
          <td>{{ record.minute_close_before_result }}</td>
          <td>{{ record.minute_allow_cancel_betting }}</td>
          <td>{{ record.num_day_allow_payout }}</td>
          <td class="text-center">
            <span class="badge badge-success" v-if="!record.inactive">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'gameSetting',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/gameSetting', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.gameSetting.search
      },
      set(newValue) {
        this.$store.commit('administrator/gameSetting/SET_SEARCH', newValue)
        this.$store.commit('administrator/gameSetting/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('gameSetting.settingName') },
        { name: this.$t('gameSetting.beforeClose') },
        { name: this.$t('gameSetting.cancelBetting') },
        { name: this.$t('gameSetting.numberDayPayout') },
        { name: this.$t('gameSetting.active'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/gameSetting/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'game-setting-create' })
    },
    edit(record) {
      this.$store.commit('administrator/gameSetting/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'game-setting-edit',
        params: { id: record.game_setting_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gameSetting/RESET_STATE')
    next()
  }
}
</script>
